/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_AppInputs */

const th_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตั้งแอป`)
};

const en_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install app`)
};

const ja_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリをインストール`)
};

const zh_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装应用`)
};

const es_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalar la aplicación`)
};

const pt_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalar o aplicativo`)
};

const id_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang aplikasi`)
};

const fr_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer l’application`)
};

const tl_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-install ang app`)
};

const vi_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài ứng dụng`)
};

const ko_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱 설치`)
};

const de_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App installieren`)
};

const ru_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить приложение`)
};

const tr_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulamayı yükle`)
};

const it_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installa l'app`)
};

const pl_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zainstaluj aplikację`)
};

const uk_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встановити застосунок`)
};

const hi_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐप इंस्टॉल करें`)
};

const ar_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تثبيت التطبيق`)
};

const ms_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang aplikasi`)
};

const bn_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপ ইনস্টল করুন`)
};

const zh_tw2_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝應用程式`)
};

const zh_hk2_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝應用程式`)
};

const ur_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایپ انسٹال کریں`)
};

const fa_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نصب برنامه`)
};

const sw_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakinisha programu`)
};

const nl_install_app = /** @type {(inputs: Install_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App installeren`)
};

/**
* | output |
* | --- |
* | "Install app" |
*
* @param {Install_AppInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const install_app = /** @type {((inputs?: Install_AppInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_AppInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_install_app(inputs)
	if (locale === "ja") return ja_install_app(inputs)
	if (locale === "zh") return zh_install_app(inputs)
	if (locale === "es") return es_install_app(inputs)
	if (locale === "pt") return pt_install_app(inputs)
	if (locale === "id") return id_install_app(inputs)
	if (locale === "fr") return fr_install_app(inputs)
	if (locale === "tl") return tl_install_app(inputs)
	if (locale === "vi") return vi_install_app(inputs)
	if (locale === "ko") return ko_install_app(inputs)
	if (locale === "de") return de_install_app(inputs)
	if (locale === "ru") return ru_install_app(inputs)
	if (locale === "tr") return tr_install_app(inputs)
	if (locale === "it") return it_install_app(inputs)
	if (locale === "pl") return pl_install_app(inputs)
	if (locale === "uk") return uk_install_app(inputs)
	if (locale === "hi") return hi_install_app(inputs)
	if (locale === "ar") return ar_install_app(inputs)
	if (locale === "ms") return ms_install_app(inputs)
	if (locale === "bn") return bn_install_app(inputs)
	if (locale === "zh-TW") return zh_tw2_install_app(inputs)
	if (locale === "zh-HK") return zh_hk2_install_app(inputs)
	if (locale === "ur") return ur_install_app(inputs)
	if (locale === "fa") return fa_install_app(inputs)
	if (locale === "sw") return sw_install_app(inputs)
	if (locale === "nl") return nl_install_app(inputs)
	return en_install_app(inputs)
});